export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        id: 3,
        label: 'menuitems.users.text',
        //icon: 'fa-users',
        icon: 'ri-shield-user-fill',
        link: '/users'
    },
    {
        id: 4,
        label: 'menuitems.consumers.text',
        icon: 'ri-team-fill',
        link: '/consumers'
    },
    {
        id: 5,
        label: 'menuitems.productions.text',
        icon: 'mdi mdi-factory',
        link: '/productions'
    },
    {
        id: 6,
        label: "menuitems.settings.text",
        icon: 'ri-settings-5-fill',
        subItems: [
            {
                id: 7,
                label: "menuitems.settings.list.company_type",
                link: '/setting/types'
            }
        ]
    }
]